"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseButton, type BaseButtonProps } from "./button";
import ConEdisonButton, {
  type ConEdisonButtonProps,
} from "./button.con-edison";
import FreemanButton, { type FreemanButtonProps } from "./button.freeman";
import HCButton, { type HCButtonProps } from "./button.hc";
import type { OptionalTenantProp } from "../../../types";

export function Button(
  props: (
    | BaseButtonProps
    | ConEdisonButtonProps
    | FreemanButtonProps
    | HCButtonProps
  ) &
    OptionalTenantProp,
) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant ?? contextTenant?.id;

  switch (tenantRefId) {
    case "freeman":
      return <FreemanButton {...props} />;
    case "con-edison":
      return <ConEdisonButton {...props} />;
    case "hc":
      return <HCButton {...props} />;
    case "tilli":
    default:
      return <BaseButton {...props} />;
  }
}
